// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type SlackListsDownloadGetResponse = SlackAPIResponse & {
  download_url?: string;
  error?: string;
  needed?: string;
  ok: boolean;
  provided?: string;
  response_metadata?: ResponseMetadata;
  status?: string;
  warning?: string;
};

export interface ResponseMetadata {
  messages?: string[];
}
